import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';

var elementProto = Object.create(HTMLAnchorElement.prototype);

elementProto.createdCallback = function() {
}
elementProto.attachedCallback = function() {
	var self = this;
	var href = this.href;
	var cn = 'url=';
	var parts = href.split(cn);

	if (parts.length === 1) {
		cn = 'u=';
		parts = href.split(cn);
	}

	if (!parts[1]) {
		parts[1] = window.location.href;
		this.href = parts.join(cn);
	}

	this.addEventListener('click', function(e) {
		var wh = resizeStore.getData().height;
		var ww = resizeStore.getData().width;
		var top, left;
		var width  = 600;
		var height = 400;

		e.preventDefault();

		top  = (wh - height)/2;
		left = (ww - width)/2;

		window.open(
			self.href,
			'Share',
			'top=' + top + ', left=' + left + ', width=' + width + ', height=' + height + '');
	});
}
elementProto.detachedCallback = function() {
}

document.registerElement('share-link', {
	prototype: elementProto,
	extends: 'a'
});